
<div class="modal-custom">
  <div class="modal-header">
    <h4 class="modal-title"><span class="fa fa-bell text-primary"></span><span class="ml-2">User(s) Export</span></h4>
    <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
  </div>


  <div class="modal-body">
    <div>
      <div class="font-weight-bold">Do you want to continue with the export process?</div>
      <div class="mt-2"> It may take a while, but you can continue using the application. When the download completes, the browser should show you a notification.</div>
    </div>

    <div  class="mt-4">
      <h5 class="text-bold">The following filters will be applied:</h5>
      <table>
        <tr>
          <th>First Name:</th>
          <td>{{filters.firstName}}</td>
        </tr>
        <tr>
          <th>Last Name:</th>
          <td>{{filters.lastName}}</td>
        </tr>
        <tr>
          <th>Search:</th>
          <td>{{filters.userName}}</td>
        </tr>
        <!-- <tr>
          <th>E-mail:</th>
          <td>{{filters.email}}</td>
        </tr> -->
        <tr>
            <th>Status:</th>
            <td>{{filters.status}}</td>
        </tr>

      </table>
    </div>
  </div>
  <div class="modal-footer ">
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="accept()">Export</button>
    <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">Cancel</button>
  </div>
</div>
